import { ComponentChild, FunctionComponent } from "preact";

import * as dateish from "@/dateish";

type CalMapper<T> = {
  doy?: (doy: dateish.DoY) => T
  moy?: (moy: dateish.MoY) => T
}

export type CalendarProps = { // TODO: Transpose the mappers
  cells?: CalMapper<ComponentChild> // TODO: Full-cell replacement vs overlays/adornment
  styles?: CalMapper<any>
  classes?: CalMapper<string>
}

export const CalendarYearless: FunctionComponent<CalendarProps> = (props) => {
  const months = dateish.yearlessMonths();
  return <div class='calendar'>
    { months.map(m => <CalendarMonth month={m} {...props} />) }
  </div>;
}

export const CalendarMonth: FunctionComponent<CalendarProps & {
  month: dateish.CalMonth
}> = ({ month, cells, styles }) => {
  return <table class='month'>
    <thead><tr><td class='month-name' colSpan={7}>
      { month.month.name /* TODO: Avoid the month.month */}
      { cells?.moy && cells.moy(month.month.mm) }
    </td></tr></thead>
    <tbody>{ month.weeks.map(w => <CalendarWeek week={w} cells={cells} styles={styles} />) }</tbody>
  </table>;
}

export const CalendarWeek: FunctionComponent<CalendarProps & {
  week: dateish.CalWeek
}> = ({ week, cells, styles }) => {
  return <tr class='week'>{ week.days.map(d => {
    return <CalendarDay day={ d } cells={cells} styles={styles} />
  }) }</tr>;
}

export const CalendarDay: FunctionComponent<CalendarProps & {
  day: dateish.CalDay
}> = ({ day, cells, styles }) => {
  // TODO: Need a way to style each day with a different color too
  return <td class='day' style={ styles?.doy?.(day.doy) } >
    <time class='date'>{day.dom}</time>
    { cells?.doy?.(day.doy) ?? null }
  </td>;
}
